import React from "react";

const ContactInfo = () => {
  return (
    <section className="bg-[#f0fff0] text-gray-800 py-8 px-4 md:px-16 rounded-lg shadow-sm max-w-4xl mx-auto">
      <p><span className="font-semibold text-[#880808]">Address:</span> B-1-301 SPRING PARK, OPP NARMADA VASAHAT, NR HEAVEN PARK RAMDEV NARGAR, AHMEDABAD, GUJARAT 380015.</p>

      {/* <p className="mt-2"><span className="font-semibold text-[#880808]">Telephone No.:</span> +91 22 26843169, 26831314</p> */}

      <p className="mt-2"><span className="font-semibold text-[#880808]">Mobile No.:</span> +91 94279 52027</p>

      <p className="mt-2"><span className="font-semibold text-[#880808]">E-mail:</span> <a href="mailto:nirmalsahaja.amd@gmail.com" className="text-purple-700 hover:underline">nirmalsahaja.amd@gmail.com</a></p>

      <p className="mt-2"><span className="font-semibold text-[#880808]">Websites:</span> <a href="http://shreenirmala.org/" className="text-purple-700 hover:underline">www.shreenirmala.org</a></p>

      <p className="mt-4 font-semibold text-[#880808]">Main Meditation Center, Paldi, Ahmedabad: <span className="font-normal text-gray-700">On every Sunday at 8:00AM</span></p>
    </section>
  );
};

export default ContactInfo;
